module.exports = __webpack_public_path__ + "img/p4.69bba225.png";